import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { getAPI, postAPI, reinitialiseAPI } from 'store/apiReducer';
import PropTypes from 'prop-types';
import { LoaderMi, Container, Row, Col } from '@si-armes/dsfr-react';
import usagerClientReducer from 'store/usagerReducer';
import {
    API_GENERER_CODE_VALIDATION,
    API_GET_PROFIL,
    API_MODIFIER_RESPONSABLE_LEGAL,
    API_RECUPERER_INFORMATIONS_PERSONNELLES,
    CONTEXT_API_RECUPERER_INFORMATIONS_PERSONNELLES,
    CONTEXT_GENERER_CODE_VALIDATION,
    CONTEXT_GET_PROFIL,
    CONTEXT_MODIFIER_RESPONSABLE_LEGAL,
} from 'constants/apiUrls.constants';
import FormulaireModification from '../components/FormulaireModification';

const apiConfig = {
    modifier: API_MODIFIER_RESPONSABLE_LEGAL,
    context: CONTEXT_MODIFIER_RESPONSABLE_LEGAL,
    stateKey: 'modifierResponsableLegal',
    getProfil: API_GET_PROFIL,
    contextGetProfil: CONTEXT_GET_PROFIL,
    recupererInformations: API_RECUPERER_INFORMATIONS_PERSONNELLES,
    contextRecupererInformations: CONTEXT_API_RECUPERER_INFORMATIONS_PERSONNELLES,
    genererCode: API_GENERER_CODE_VALIDATION,
    contextGenererCode: CONTEXT_GENERER_CODE_VALIDATION,
    dataProvider: (dataCompteUsager) => dataCompteUsager?.responsableLegal,
};

const uiConfig = {
    titre: 'Modification des informations du responsable légal',
    description:
        'Vous pouvez modifier directement vos informations du responsable légal en saisissant les informations dans les champs ci-dessous. Certaines informations du responsable légal sont grisées car elles ne sont pas modifiables directement. Pour pouvoir les modifier, veuillez en faire la demande via le formulaire de contact situé en bas de l\'écran en cliquant sur le lien "Nous contacter".',
    titreModale: 'Modification des informations du responsable légal',
};

const ModifierResponsableLegal = ({
    getApi,
    postApi,
    reinitialiseApi,
    isLoadingCompteUsager,
    isLoadingModification,
    erreurModification,
    messageModification,
    isLoadingVerificationCodeValidation,
    erreurVerificationCodeValidation,
    messageVerificationCodeValidation,
    dataCompteUsager,
}) => {
    useEffect(() => {
        reinitialiseApi(apiConfig.context);
        getApi(
            usagerClientReducer,
            apiConfig.recupererInformations,
            apiConfig.contextRecupererInformations,
        );
        return () => {
            reinitialiseApi(apiConfig.context);
        };
    }, []);

    if (isLoadingCompteUsager || !dataCompteUsager || !dataCompteUsager.responsableLegal) {
        return (
            <Container>
                <Row>
                    <Col col={12}>
                        <LoaderMi taille="md" />
                    </Col>
                </Row>
            </Container>
        );
    }

    return (
        <FormulaireModification
            getApi={getApi}
            postApi={postApi}
            reinitialiseApi={reinitialiseApi}
            dataCompteUsager={dataCompteUsager}
            isLoadingCompteUsager={isLoadingCompteUsager}
            isLoadingModification={isLoadingModification}
            erreurModification={erreurModification}
            messageModification={messageModification}
            isLoadingVerificationCodeValidation={isLoadingVerificationCodeValidation}
            erreurVerificationCodeValidation={erreurVerificationCodeValidation}
            messageVerificationCodeValidation={messageVerificationCodeValidation}
            apiConfig={apiConfig}
            uiConfig={uiConfig}
        />
    );
};

ModifierResponsableLegal.propTypes = {
    getApi: PropTypes.func.isRequired,
    postApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    isLoadingCompteUsager: PropTypes.bool,
    isLoadingModification: PropTypes.bool,
    erreurModification: PropTypes.bool,
    messageModification: PropTypes.string,
    isLoadingVerificationCodeValidation: PropTypes.bool,
    erreurVerificationCodeValidation: PropTypes.string,
    messageVerificationCodeValidation: PropTypes.string,
    dataCompteUsager: PropTypes.shape({
        responsableLegal: PropTypes.object,
    }),
};

const mapStateToProps = (state) => {
    const { isLoading: isLoadingCompteUsager, data: dataCompteUsager } =
        state.monCompte.recupererInformationsPersonnelles;

    const {
        isLoading: isLoadingModification,
        erreur: erreurModification,
        message: messageModification,
    } = state.monCompte.modifierResponsableLegal;

    const {
        isLoading: isLoadingVerificationCodeValidation,
        erreur: erreurVerificationCodeValidation,
        message: messageVerificationCodeValidation,
    } = state.monCompte.verifierCodeValidation;

    return {
        isLoadingCompteUsager,
        dataCompteUsager,
        isLoadingModification,
        erreurModification,
        messageModification,
        isLoadingVerificationCodeValidation,
        erreurVerificationCodeValidation,
        messageVerificationCodeValidation,
    };
};

const mapDispatchToProps = {
    getApi: getAPI,
    postApi: postAPI,
    reinitialiseApi: reinitialiseAPI,
};

export default connect(mapStateToProps, mapDispatchToProps)(ModifierResponsableLegal);
